module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_03.png?e143b878aa5ddbe8694e3b6adcb5e62a";